import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import './Login.css';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }

    if (password.length < 6) {
      setError('Le mot de passe doit contenir au moins 6 caractères');
      return;
    }

    setLoading(true);

    try {
      const result = await authAPI.resetPassword(token, password);
      if (result.success) {
        setSuccess(true);
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className='login-container'>
        <div className='login-card'>
          <h1>Mot de passe réinitialisé</h1>
          <p style={{ color: '#27ae60' }}>Votre mot de passe a été réinitialisé avec succès !</p>
          <button className='btn-primary' onClick={() => navigate('/login')}>
            Se connecter
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className='login-container'>
      <div className='login-card'>
        <h1>Nouveau mot de passe</h1>
        <p>Entrez votre nouveau mot de passe ci-dessous.</p>

        {error && <div className='error-message'>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className='form-group'>
            <label htmlFor='password'>Nouveau mot de passe</label>
            <input
              type='password'
              id='password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder='Entrez votre nouveau mot de passe'
              required
            />
          </div>

          <div className='form-group'>
            <label htmlFor='confirmPassword'>Confirmer le mot de passe</label>
            <input
              type='password'
              id='confirmPassword'
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder='Confirmez votre mot de passe'
              required
            />
          </div>

          <button type='submit' className='btn-primary' disabled={loading}>
            {loading ? 'Réinitialisation...' : 'Réinitialiser le mot de passe'}
          </button>
        </form>

        <div className='login-footer'>
          <p><Link to='/login'>Retour à la connexion</Link></p>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;

